export const DEFAULT_HOP_VALUE = 'Auto';
